/* eslint-disable no-script-url */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import sessionActions from '../../actions/SessionActions';
import { t } from '../../services/i18nService';
import uiActions from '../../actions/UIActions';
import storeManager from '../../store/StoreManager';
import styles from './options.scss';

import OptionsTopBar from './OptionsTopBar';
import OptionsChoiceList from './OptionsChoiceList';
import globalsService from '../../services/GlobalsService';
import { getA11yAttributesV2 } from '../../services/a11yIIBScreenReaderService';
import uiService from '../../services/UIService';
import { UI_OPTIONS_LIST } from '../../constants/UIConstants';

class OptionsContrastChooser extends React.Component {
    static propTypes = {
        ui: PropTypes.object,
    };

    /**
     * @param {string} contrastOption: CONTRAST_OPTIONS
     * */
    handleContrastOptionChange = (contrastOption) => {
        const store = storeManager.getStore();
        store.dispatch(uiActions.uiSetContrastOption(contrastOption));
        uiService.setUISettingInLocalStorageForTestTaker(
            UI_OPTIONS_LIST.CONTRAST_OPTION,
            contrastOption
        );
    };

    render() {
        const { ui } = this.props;
        /*
            Based on whether the local storage is available for contrast option,
            we are storing the value in savedOrDefaultContrast.
            If it is available, then we store that value, otherwise the default value
        */
        const savedOrDefaultContrast = uiService.getUISettingFromLocalStorageForTestTaker(
            UI_OPTIONS_LIST.CONTRAST_OPTION
        );
        const current = ui.contrastOption ? ui.contrastOption : savedOrDefaultContrast;
        const options = ui.a11yContrastOptions;
        const assetRoot = globalsService.getAssetRoot();

        const choices = options.map((option) => {
            return {
                identifier: option,
                title: t(`options.contrast-${option}`),
                isSelected: current === option,
                imageSrc: `${!assetRoot ? '' : `${assetRoot}/`}images/contrast-options/${option}.svg`,
                a11yLabel: `${t('options.contrastSettings')}, ${t(`options.contrast-${option}`)}`,
            };
        });

        return (
            <div>
                <OptionsTopBar
                    title={t('options.contrast')}
                    showOptionsButton
                    exitButtonProps={getA11yAttributesV2({ 'aria-label': t('options.closeOptionsMenu') })}
                    optionsButtonProps={getA11yAttributesV2({ 'aria-label': t('options.backToOptionsList') })}
                />
                <div className={styles.mainContentArea} role="main">
                    <OptionsChoiceList
                        selectionHandler={this.handleContrastOptionChange}
                        choices={choices}
                        {...getA11yAttributesV2({ a11yLabel: t('options.selectContrast') })}
                    />
                </div>
            </div>
        );
    }
}


function mapStateToProps(state) {
    return {
        ui: state.ui,
    };
}

const OptionsContrast = connect(mapStateToProps, sessionActions)(OptionsContrastChooser);
export default OptionsContrast;
